export default __webpack_public_path__ + "static/Prom_Visioedge_Intro-fd49f2a9738e3d2746b1d41b683e5745.pdf";